// apiService.js
import { get, post } from "aws-amplify/api";
import currentUserToken from "./CurrentUserToken";

export const hrGetUserManager = async (
  selectedDate,
  selectedCountry,
  selectedLegalEntity,
  selectedManager,
  selectedJobFunction,
  selectedJobFamily,
  selectedGrade,
  selectedPersonTypes,
  selectedWorkerTypes,
  selectedDepartment,
  selectedCeoLevel
) => {
  try {
    const response = get({
      apiName: "hrAPI",
      path: "/user/manager/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          date: selectedDate,
          country: selectedCountry || "",
          legal_entity: selectedLegalEntity || "",
          manager_email: selectedManager || "",
          job_function: selectedJobFunction || "",
          job_family: selectedJobFamily || "",
          grade: selectedGrade || "",
          person_type: selectedPersonTypes || "",
          worker_type: selectedWorkerTypes || "",
          department: selectedDepartment || "",
          ceo_h_level: selectedCeoLevel || "",
        },
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
    const data = await body.json();
    return data;
  } catch (error) {
    console.error("Error getUserManager:", error);
    throw error;
  }
};

export const hrGetSimulation = async () => {
  try {
    const response = get({
      apiName: "hrAPI",
      path: "/simulation/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
    const data = await body.json();
    return data;
  } catch (error) {
    console.error("Error hrGetSimulation:", error);
    throw error;
  }
};

export const hrGetFilters = async (selectedDate) => {
  try {
    const response = get({
      apiName: "hrAPI",
      path: "/filters/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          date: selectedDate,
        },
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
    const data = await body.json();
    return data;
  } catch (error) {
    console.error("Error getFilters:", error);
    throw error;
  }
};
export const hrGetSimulationInfo = async (simulationId) => {
  try {
    const response = get({
      apiName: "hrAPI",
      path: "/simulation/info/get",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          simulation_id: simulationId, //tipo string
        },
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
    const data = await body.json();
    return data;
  } catch (error) {
    console.error("Error getUserManager:", error);
    throw error;
  }
};

export const hrPostNewSimulation = async (payload) => {
  try {
    const response = post({
      apiName: "hrAPI",
      path: "/simulation/new",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: payload,
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
    const data = await body.json();
    return data;
  } catch (error) {
    console.error("Error getUserManager:", error);
    throw error;
  }
};
export const hrPostSimulationChanges = async (simulationId, payload) => {
  try {
    const response = post({
      apiName: "hrAPI",
      path: "/simulation/edit",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: { simulation_id: simulationId },
        body: payload,
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
  } catch (error) {
    console.error("Error hrPostSimulationChanges:", error);
    throw error;
  }
};
export const hrPostDeleteSimulation = async (simulationId) => {
  try {
    const response = post({
      apiName: "hrAPI",
      path: "/simulation/delete",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: { simulation_id: simulationId },
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
    const data = await body.json();
    return data;
  } catch (error) {
    console.error("Error hrPostSimulationChanges:", error);
    throw error;
  }
};

export const hrPostUserPrompt = async (payload) => {
  try {
    const response = post({
      apiName: "hrAPI",
      path: "/smartReport/userPrompt",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        body: payload,
      },
    });
    const { statusCode, body } = await response.response; //attendo la risposta effettiva
    if (statusCode !== 200) {
      //controllo lo status della risposta
      throw new Error(`API Error: status ${statusCode}`);
    }
    const data = await body.json();
    return data;
  } catch (error) {
    console.log("errore chiamata postUserPrompt ", error);
  }
};
// Fetch alarms
export const fetchAlarms = async (
  startDate,
  endDate,
  states = null,
  language
) => {
  try {
    const response = await get({
      apiName: "TelemonitoringAPI",
      path: "/alarms",
      options: {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${await currentUserToken()}`,
        },
        queryParams: {
          start_date: startDate,
          end_date: endDate,
          state: states,
          language: language,
        },
      },
    });
    const { body } = await response.response;
    return await body.json();
  } catch (error) {
    console.error("Error fetching alarms:", error);
    throw error;
  }
};
